<template>
  <div
    id="childrens-carousel"
  >
    <v-carousel v-model="model"
      continuous
      cycle
      hide-delimiters
      @change=onCarousel>
      <v-carousel-item
        v-for="(item,i) in childrens"
        :key="i"
        :src="getPhotoUrl(item)"
        style="background: inherit;"
      >
        <v-card
          style="width: 100%; height: 100%;">
          <img
            :src="getPhotoUrl(item)"
            style="width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%);"
          >
          </img>
        </v-card>
      </v-carousel-item>
    </v-carousel>
    <base-card
      color="rgba(0, 0, 0, 0)"
      class="pa-3"
      v-if="children"
    >
      <v-container
        grid-list-xl
        pa-0
      >
        <v-layout wrap>
          <v-flex
            xs12
            md12
            pa-0
          >
            <base-subheading class="mt-3">
              {{children.name}}
            </base-subheading>
            <v-list class="transparent pt-0 pb-3">
              <v-list-tile v-if="children.birthday">
                <v-list-tile-title style="max-width: 200px; white-space: pre-line;">Дата рождения</v-list-tile-title>
                <v-list-tile-sub-title style="white-space: pre-line;">
                  {{children.birthday}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile v-if="children.diagnosis">
                <v-list-tile-title style="max-width: 200px; white-space: pre-line;">Диагноз</v-list-tile-title>
                <v-list-tile-sub-title style="white-space: pre-line;">
                  {{children.diagnosis}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile v-if="children.diagnosis_main">
                <v-list-tile-title style="max-width: 200px; white-space: pre-line;">Основной диагноз</v-list-tile-title>
                <v-list-tile-sub-title style="white-space: pre-line;">
                  {{children.diagnosis_main}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile v-if="children.diagnosis_companion">
                <v-list-tile-title style="max-width: 200px; white-space: pre-line;">Сопутствующий диагноз</v-list-tile-title>
                <v-list-tile-sub-title style="white-space: pre-line;">
                  {{children.diagnosis_companion}}
                </v-list-tile-sub-title>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </base-card>
  </div>
</template>

<styles lang='css'>
  #childrens-carousel .v-list__tile {
    height: auto !important;
  }
  #childrens-carousel .v-carousel__prev .v-btn,
  #childrens-carousel .v-carousel__next .v-btn {
    color: #4287F5;
  }
</styles>

<script>
  import axios from 'axios'

  export default {
    data: function() {
      return {
        childrens: [],
        children: {},
        model: null
      }
    },
    mounted () {
      axios.get('/static/data/childrens.json')
        .then(response => {
          this.childrens = response.data
          this.model = Math.floor(Math.random() * (this.childrens.length - 1))
          this.onCarousel(this.model)
        }).catch(error => {
          console.log(error)
        })
    },
    methods: {
      getPhotoUrl (item) {
        return '/static/childrens/' + item.photo
      },
      onCarousel (number) {
        this.children = this.childrens[number]
      }
    }
  }
</script>
